import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexResponseType,
  ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexResponseType>(
      "/api/managers/weekly_reports/employee_survey_progresses",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersWeeklyReportsEmployeeSurveyProgressesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiManagersWeeklyReportsEmployeeSurveyProgressesIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisManagersWeeklyReportsEmployeeSurveyProgressesIndex",
      params,
    ],
    queryFn: () => request({ params }),
  });
};
